import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { Numeric } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { LeiCode } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { FsaAuthorisationStatusArray, FsaAuthorisationStatusMap } from "../../../../../Network/Resource/Content";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { FsaAuthorisationStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/FsaAuthorisationStatus";
import { FirmType } from "../../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { Table } from "../../../../../../Shared/Table/Table";
import { groupBy } from "lodash";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { Button } from "../../../../../../../react-core/Html/Button";
import { FsaSourcedCompanyDetailModel } from "../../../../../../../Wrap/Models/Models/Company/FsaSourcedCompanyDetailModel";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { FsaType } from "../../../../../../../Wrap/Constants/Enums/Domain/FsaType";

interface IFCAProps extends React.Props<FCA> {
    isReview?: boolean;
    data: FirmInstruction;
    taggedNetwork: boolean;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface IFCAState {
    FcaInfoText: string;
    FsaPermissions: any;
    UsingFsaDetailFromFile: boolean;
    SourcedCompanyDetail: FsaSourcedCompanyDetailModel;
    IsFindCompanyBusy: boolean;
    NoMatchFound: boolean;
}

export class FCA extends FormComponent<IFCAProps, IFCAState> {
    constructor(props: any) {
        super(props);
        this.state = {
            FcaInfoText: null,
            FsaPermissions: null,
            UsingFsaDetailFromFile: false,
            SourcedCompanyDetail: null,
            IsFindCompanyBusy: false,
            NoMatchFound: false,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        if (this.props.data.FsaAuthorisationStatus == 0) {
            this.props.onChange({ FsaAuthorisationStatus: FsaAuthorisationStatus.Authorised });
        }

        this.GetSourcedCompanyDetailsFromFile(false);

        CompanyWizardAction.check(this.props.data.FsaAuthorisationNumber, (data) => {
            if (data.IsExisted) {
                this.setState({ FcaInfoText: "FSA Authorization Number already existed" });
            } else {
                this.setState({ FcaInfoText: null });
            }
        });

        const { data } = this.props;
        this.SetPermissionTODisplay(data.FsaPermissions);
    }

    SetPermissionTODisplay(permission: Array<FsaPermission>) {
        const activities = groupBy(permission, "FsaRegulatedActivity.FsaRegulatedActivityId");

        Object.keys(activities).map((activity) => {
            const header: FsaPermission = {
                FsaInvestmentType: {
                    FsaInvestmentTypeId: 0,
                    ExternalId: 0,
                    Name: activities[activity][0].FsaRegulatedActivity.Name,
                },
                FsaRegulatedActivity: activities[activity][0].FsaRegulatedActivity,
                IsPermit: activities[activity].some((x) => x.IsPermit || x.IsInclude),
                IsInclude: false,
            };
            activities[activity] = [header].concat(activities[activity]);
        });

        this.setState({ FsaPermissions: activities });
    }

    GetSourcedCompanyDetailsFromFile(shouldChangeDataInInstruction: boolean) {
        if (shouldChangeDataInInstruction) {
            this.setState({ IsFindCompanyBusy: true });
        }

        CompanyWizardAction.getFsaSourcedCompanyDetail(
            this.props.data?.FsaAuthorisationNumber,
            (data: FsaSourcedCompanyDetailModel) => {
                if (
                    data != null &&
                    !CommonHelper.isNullOrEmpty(data?.RegisteredCompanyName) &&
                    data?.Status != FsaAuthorisationStatus.NotSpecified &&
                    this.props.data.FsaType !== FsaType.Offshoreregistered
                ) {
                    if (shouldChangeDataInInstruction) {
                        if (
                            this.props.data.FsaType == FsaType.Fcaregistered &&
                            data.Status == FsaAuthorisationStatus.Authorised
                        ) {
                            data.SourcedCompanyPermission.map((x) =>
                                x.IsPermit !== x.IsInclude ? (x.IsInclude = x.IsPermit) : x.IsInclude
                            );
                        }
                        this.props.onChange({
                            FsaPermissions: data.SourcedCompanyPermission,
                        });
                        this.SetPermissionTODisplay(data.SourcedCompanyPermission);
                    }
                    this.props.onChange({
                        FsaAuthorisationStatus: data.Status,
                    });
                    this.setState({
                        UsingFsaDetailFromFile: true,
                        SourcedCompanyDetail: data,
                        NoMatchFound: false,
                        IsFindCompanyBusy: false,
                    });
                } else if (this.props.data.FsaType == FsaType.Offshoreregistered) {
                    this.props.onChange({
                        FsaAuthorisationStatus: FsaAuthorisationStatus.Authorised,
                    });
                    this.setState({
                        UsingFsaDetailFromFile: false,
                        SourcedCompanyDetail: null,
                        IsFindCompanyBusy: false,
                    });
                } else {
                    if (shouldChangeDataInInstruction) {
                        this.setState({
                            NoMatchFound: true,
                        });
                        this.props.onChange({
                            FsaAuthorisationStatus: FsaAuthorisationStatus.Pendingauthorisation,
                        });
                    }
                    this.setState({
                        UsingFsaDetailFromFile: false,
                        SourcedCompanyDetail: null,
                        IsFindCompanyBusy: false,
                    });
                }
            }
        );
    }
    render() {
        const { data, isReview, taggedNetwork } = this.props;
        const { FsaPermissions } = this.state;
        return (
            <>
                {SectionHeader("FCA authorization")}
                <TextBoxEditor
                    disabled={isReview}
                    label={`FCA/Trading reference:${
                        this.props.data.FirmType == FirmType.DirectlyAuthorised ? "*" : ""
                    }`}
                    required={
                        this.props.data.FirmType == FirmType.DirectlyAuthorised
                            ? `Please enter FCA/Trading reference:`
                            : null
                    }
                    value={data.FsaAuthorisationNumber}
                    maxLength={8}
                    regex={{ errorMessage: "Must be numeric values only", value: Numeric }}
                    onChange={(v) => {
                        this.props.onChange({ FsaAuthorisationNumber: v });
                        if (this.props.data.FirmType == FirmType.AppointedRepresentative) {
                            CompanyWizardAction.check(v, (data) => {
                                if (data.IsExisted) {
                                    this.setState({ FcaInfoText: "FCA Authorization Number already existed" });
                                } else {
                                    this.setState({ FcaInfoText: null });
                                }
                            });
                        }
                    }}
                    isDebounce
                />
                {this.state.FcaInfoText && <Alert alertType={AlertType.Warning} message={this.state.FcaInfoText} />}
                {taggedNetwork && (
                    <CheckboxGroup
                        type="block"
                        options={[
                            {
                                label: "Inherit FCA/Trading status",
                                value: data.FcaStatusInherited,
                                onChange: (v) => this.props.onChange({ FcaStatusInherited: v }),
                                disabled: isReview,
                            },
                        ]}
                    />
                )}
                {!(data.FcaStatusInherited && taggedNetwork) && (
                    <Button
                        className={`btn primary ${this.state.IsFindCompanyBusy ? "is-busy" : ""}`}
                        onClick={() => {
                            this.GetSourcedCompanyDetailsFromFile(true);
                        }}
                    >
                        Find company
                    </Button>
                )}

                {this.state.UsingFsaDetailFromFile &&
                    !CommonHelper.isNullOrEmpty(this.state.SourcedCompanyDetail?.RegisteredCompanyName) && (
                        <>
                            <div>
                                <span>
                                    Registered Firm Name: {this.state.SourcedCompanyDetail?.RegisteredCompanyName}
                                </span>
                            </div>
                            <div>
                                <span>
                                    Last Update Date:
                                    {this.state.SourcedCompanyDetail?.LastUpdated != null
                                        ? JsonDateParser.getFormatDateString(
                                              JsonDateParser.toDate(this.state.SourcedCompanyDetail?.LastUpdated),
                                              "dd-MM-yyyy hh:mm:ss",
                                              true,
                                              true
                                          )
                                        : ""}
                                </span>
                            </div>
                            <div>
                                <span>
                                    Last Status Change Date:
                                    {this.state.SourcedCompanyDetail?.StatusLastChanged != null
                                        ? JsonDateParser.getFormatDateString(
                                              JsonDateParser.toDate(this.state.SourcedCompanyDetail?.StatusLastChanged),
                                              "dd-MM-yyyy hh:mm:ss",
                                              true,
                                              true
                                          )
                                        : ""}
                                </span>
                            </div>
                        </>
                    )}
                {this.state.NoMatchFound && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={"Can not find a registered company with the FCA reference number"}
                    />
                )}
                {!data.FcaStatusInherited && (
                    <SelectEditor
                        disabled={
                            isReview ||
                            this.state.UsingFsaDetailFromFile ||
                            this.state.NoMatchFound ||
                            this.props.data.FsaType == FsaType.Offshoreregistered
                        }
                        options={FsaAuthorisationStatusArray}
                        getText={(v) => {
                            return FsaAuthorisationStatusMap[v];
                        }}
                        required={
                            this.props.data.FsaType !== FsaType.Offshoreregistered
                                ? "Please select FCA/Trading status"
                                : null
                        }
                        label="FCA/Trading status:"
                        selected={data.FsaAuthorisationStatus == 0 ? null : data.FsaAuthorisationStatus}
                        onChange={(v) =>
                            this.props.onChange({ FsaAuthorisationStatus: v ? v : FsaAuthorisationStatus.Authorised })
                        }
                    />
                )}

                {data.FsaAuthorisationStatus !== FsaAuthorisationStatus.NotSpecified && (
                    <>
                        {FsaPermissions &&
                            Object.keys(FsaPermissions).map((activity) => {
                                return (
                                    <Table
                                        data={FsaPermissions[activity]}
                                        col={[
                                            {
                                                title: "",
                                                key: "FsaInvestmentType.Name",
                                                render: (data, row, index) => {
                                                    return data;
                                                },
                                            },
                                            {
                                                title: "FSA Permission",
                                                key: "IsPermit",
                                                render: (data, row, index) => {
                                                    return (
                                                        <CheckboxEditor
                                                            label=""
                                                            cssWrapper="square-checkbox block mt-19"
                                                            value={data}
                                                            onChange={(v) => {
                                                                FsaPermissions[activity][index].IsPermit = v;
                                                                if (index != 0) {
                                                                    this.props.data.FsaPermissions.find(
                                                                        (x) =>
                                                                            x.FsaInvestmentType.FsaInvestmentTypeId ==
                                                                                row.FsaInvestmentType
                                                                                    .FsaInvestmentTypeId &&
                                                                            x.FsaRegulatedActivity
                                                                                .FsaRegulatedActivityId ==
                                                                                row.FsaRegulatedActivity
                                                                                    .FsaRegulatedActivityId
                                                                    ).IsPermit = v;
                                                                    this.props.onChange({
                                                                        FsaPermissions: this.props.data.FsaPermissions,
                                                                    });
                                                                }
                                                                this.setState({ FsaPermissions: FsaPermissions });
                                                            }}
                                                            disabled={
                                                                (index != 0 && !FsaPermissions[activity][0].IsPermit) ||
                                                                (this.state.UsingFsaDetailFromFile &&
                                                                    this.props.data.FsaType !== FsaType.Eearegistered &&
                                                                    this.props.data.FsaAuthorisationStatus !==
                                                                        FsaAuthorisationStatus.Eeaauthorised) ||
                                                                this.props.data.FsaAuthorisationStatus ==
                                                                    FsaAuthorisationStatus.Deauthorised
                                                            }
                                                        />
                                                    );
                                                },
                                            },
                                            {
                                                title: "StandardLife Access",
                                                key: "IsInclude",
                                                render: (data, row, index) => {
                                                    return (
                                                        index != 0 && (
                                                            <CheckboxEditor
                                                                label=""
                                                                cssWrapper="square-checkbox block mt-19"
                                                                value={data}
                                                                onChange={(v) => {
                                                                    FsaPermissions[activity][index].IsInclude = v;
                                                                    if (index != 0) {
                                                                        if (
                                                                            this.props.data.FsaPermissions.find(
                                                                                (x) =>
                                                                                    x.FsaInvestmentType
                                                                                        .FsaInvestmentTypeId ==
                                                                                        row.FsaInvestmentType
                                                                                            .FsaInvestmentTypeId &&
                                                                                    x.FsaRegulatedActivity
                                                                                        .FsaRegulatedActivityId ==
                                                                                        row.FsaRegulatedActivity
                                                                                            .FsaRegulatedActivityId
                                                                            ) == null
                                                                        ) {
                                                                            this.props.data.FsaPermissions = this.props.data.FsaPermissions.concat(
                                                                                FsaPermissions[activity][index]
                                                                            );
                                                                        } else {
                                                                            this.props.data.FsaPermissions.find(
                                                                                (x) =>
                                                                                    x.FsaInvestmentType
                                                                                        .FsaInvestmentTypeId ==
                                                                                        row.FsaInvestmentType
                                                                                            .FsaInvestmentTypeId &&
                                                                                    x.FsaRegulatedActivity
                                                                                        .FsaRegulatedActivityId ==
                                                                                        row.FsaRegulatedActivity
                                                                                            .FsaRegulatedActivityId
                                                                            ).IsInclude = v;
                                                                        }
                                                                        this.props.onChange({
                                                                            FsaPermissions: this.props.data
                                                                                .FsaPermissions,
                                                                        });
                                                                    }
                                                                    this.setState({
                                                                        FsaPermissions: FsaPermissions,
                                                                    });
                                                                }}
                                                                disabled={
                                                                    !FsaPermissions[activity][0].IsPermit ||
                                                                    !FsaPermissions[activity][index].IsPermit
                                                                }
                                                            />
                                                        )
                                                    );
                                                },
                                            },
                                        ]}
                                    />
                                );
                            })}
                    </>
                )}

                <TextBoxEditor
                    disabled={isReview}
                    label="LEI Code:"
                    value={data.LeiCode}
                    required={
                        this.props.data.FirmType == FirmType.AppointedRepresentative ||
                        this.props.data.FirmType == FirmType.DirectlyAuthorised
                            ? null
                            : "Please enter LEI Code"
                    }
                    maxLength={20}
                    regex={{ errorMessage: "LEI code must contain 20 characters", value: LeiCode }}
                    onChange={(v) => this.props.onChange({ LeiCode: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    onChange={(v) => this.props.onChange({ ExternalReferenceCode: v })}
                    label="External Reference Code:"
                    value={data.ExternalReferenceCode}
                    maxLength={20}
                />
            </>
        );
    }
}
